<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>SAHA GÜNCELLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">SAHA GÜNCELLEME EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">SAHA GÜNCELLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label"
                    >Güncellenecek Sahayı Seçiniz</label
                  >
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>SAHA SEÇİNİZ</option>
                    <option
                      v-for="saha in sahalar"
                      :value="saha.id"
                      :key="saha.id"
                      >{{saha.id}} - {{ saha.sahaName }}</option
                    >
                  </select>
                </div>

                <div class="form-group">
                  <label class="control-label">Toplam Delgi Sayısı</label>
                  <input
                    v-model="toplam_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Toplam Delgi Sayısı"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Delgi Çapı</label>
                  <input
                    v-model="cap_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Delgi Çapı"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Derinlik</label>
                  <input
                    v-model="derinlik"
                    class="form-control"
                    type="number"
                    placeholder="Derinlik"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Delgi Birim Fiyatı</label>
                  <input
                    v-model="fiyat_delgi"
                    class="form-control"
                    type="text"
                    placeholder="Delgi Birim Fiyatı"
                  />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahaname: "",
      sahalar: [],
      cap_delgi: "",
      derinlik: "",
      fiyat_delgi: "",
      toplam_delgi: "",
      saha_id: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    getBySaha(event) {
      var saha_id = event.target.value;
      this.saha_id = saha_id;
      var url = store.state.base_url + "AslanSahalar/getByIdSaha.php?key=123";
      var datas = { saha_id };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          var veri = response.data.data[0];
          this.cap_delgi = veri.cap_delgi;
          this.derinlik = veri.derinlik;
          this.fiyat_delgi = veri.fiyat_delgi;
          this.toplam_delgi = veri.toplam_delgi;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      console.log(this.oprone);
      if (this.cap_delgi == "") {
        this.$swal({
          text: "DELGİ ÇAPINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.derinlik == "") {
        this.$swal({
          text: "DELGİ DERİNLİĞİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }  else if (this.fiyat_delgi == "") {
        this.$swal({
          text: "DELGİ BİRİM FİYATINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.toplam_delgi == "") {
        this.$swal({
          text: "TOPLAM DELGİ SAYISINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }else {
        var url = store.state.base_url + "AslanSahalar/updateSahaData.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          cap_delgi: this.cap_delgi,
          derinlik: this.derinlik,
          fiyat_delgi: this.fiyat_delgi,
          toplam_delgi: this.toplam_delgi,
          saha_id: this.saha_id
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data == true) {
              this.$swal({
                text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              setTimeout(function() {
                location.reload();
              }, 1250);
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SahaGuncelleme.vue